import { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { AvatarMenu } from './AvatarMenu';
import { GroupListScreen } from './GroupListScreen';
import { GroupScreen } from './GroupScreen';
import { CreateGroupScreen } from './CreateGroupScreen';
import { CreateExpenseScreen } from './CreateExpenseScreen';
import { UserContext } from '../contexts/UserProvider';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

export const PostAuthLayout = () => {
    const { userData, signOutUser } = useContext(UserContext);

    return (
        <>
            <AppBar position="static">
                <Toolbar>
                    <Box sx={{ flexGrow: 1 }} />
                    <Link to="/" style={{ textDecoration: 'none', color: 'inherit', flexGrow: 0 }}>
                        <Typography variant="h5" component="h2">
                            GynoLedger
                        </Typography>
                    </Link>
                    <Box sx={{ flexGrow: 1 }} />
                    <AvatarMenu 
                        userPhoto={userData.userPhoto} 
                        displayName={userData.displayName}
                        signOutUser={signOutUser}
                    />
                </Toolbar>
            </AppBar>
            <Routes>
                <Route path="/" element={<GroupListScreen />} />
                <Route path="/new" element={<CreateGroupScreen />} />
                <Route path="/groups/:groupId" element={<GroupScreen />} />
                <Route path="/groups/:groupId/new" element={<CreateExpenseScreen />} />
            </Routes>
        </>
    );
}
